// @flow
import React from 'react';
import {
  PROFILE_ENTITIES_PROPS,
  tabDefinitionResolver
} from 'UI/components/organisms/inventoryProfiles/commons';
import TabsView from 'UI/components/templates/TabsView';
import { Endpoints } from 'UI/constants/endpoints';
import { JobOrderEntity, TabKeys } from 'UI/constants/entityTypes';
import { getProfileFileDraggableProps } from 'UI/utils';

import { useStyles } from './styles';

type CreateTabViewProps = {
  tabs: Array<Object>,
  profileTabProps: Array<Object>,
  profileMenuProps: Object,
  results: Object
};

export const createTabViewProps = ({
  tabs,
  profileTabProps,
  profileMenuProps
}: CreateTabViewProps) =>
  tabs.map(({ Component, visible = true, props = {}, id, label }) => {
    const currentTab = profileTabProps?.find(item => item.id === id);

    const profileProps = currentTab?.tabProps;

    return {
      id,
      label,
      visible: typeof visible === 'function' ? visible() : visible,
      view: Component && <Component {...props} {...profileProps} {...profileMenuProps} />
    };
  });

type ProfileTabsWrapperProps = {
  enableUrlNavigation: boolean,
  endpoint: string,
  entityType: string,
  isChangeLogsTabEnabled: boolean,
  isLoading: boolean,
  organizationStorageKey?: string | null,
  organizationSubheader: string,
  profileMenuProps: { onEditClick: () => void },
  profileTabProps: Array<Object>,
  results: Object
};

const ProfileTabsWrapper = ({
  enableUrlNavigation,
  endpoint,
  entityType,
  isChangeLogsTabEnabled,
  isLoading,
  organizationStorageKey,
  organizationSubheader,
  profileMenuProps,
  profileTabProps,
  results
}: ProfileTabsWrapperProps) => {
  const classes = useStyles();

  const entityId = entityType?.id;

  const currentEntityProps = PROFILE_ENTITIES_PROPS[entityId];
  const currentTabsProps = currentEntityProps?.defaultTabsProps || {};
  const defaultTabsProps = {
    ...currentTabsProps,
    changeLogProps: {
      tablePreferencesKey: currentEntityProps.defaultTabsProps.changeLogProps.tablePreferencesKey,
      entityId: results?.id,
      profileModule: entityType.title
    }
  };

  const tabs = [
    ...createTabViewProps({
      tabs: tabDefinitionResolver({
        entity: entityId,
        defaultTabsProps,
        enableSearchProjects: entityId !== JobOrderEntity.id,
        endpoint,
        isChangeLogsTabEnabled,
        loading: isLoading,
        overviewComponent: currentEntityProps?.overviewComponent,
        overviewProps: currentEntityProps?.overviewProps,
        profile: results,
        tabsDefinition: currentEntityProps?.getTabsDefinition
          ? currentEntityProps?.getTabsDefinition(results?.status?.id)
          : currentEntityProps?.tabsDefinition,
        fileManagerProps: {
          filesEndpoint: `${endpoint}/${Endpoints.Files}`,
          module: currentEntityProps?.fileManagerModule,
          readOnly: false,
          FileDraggableProps: getProfileFileDraggableProps()
        }
      }),
      profileTabProps,
      profileMenuProps,
      results
    })
  ];

  return (
    <TabsView
      className={classes.unsetBackground}
      enableUrlNavigation={enableUrlNavigation}
      initialTab={TabKeys.Overview}
      organizationStorageKey={organizationStorageKey}
      organizationSubheader={organizationSubheader}
      tabPanelProps={{ className: classes.overviewTab }}
      tabs={tabs}
      useIndexes={false}
    />
  );
};

ProfileTabsWrapper.defaultProps = {
  enableUrlNavigation: true
};

export default ProfileTabsWrapper;
